import styled, { css } from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

export const ImageWrapper = styled.div`
  flex-basis: 40%;
  max-height: 100px;
  img {
    max-height: 100px;
  }

  ${({ alignSelf }) =>
    alignSelf &&
    css`
      align-self: ${({ alignSelf }) => alignSelf};
    `}

  ${media.greaterThan(breakpoints.ipad)`
		max-height: 125px;
		img {
			max-height: 125px;
		}
  `}
`;

export const ImageWrapperLink = styled.a.attrs(({ theme, href, Heading }) => ({
  primary: theme.colors.primary,
  radius: theme.border.radius,
  haveLink: href !== undefined,
  "aria-label": Heading || "",
}))`
  img {
    transform: perspective(1px) translateZ(0);
    transition-duration: 0.3s;
    transition-property: transform;
  }
  aria-label: test;
  &:hover,
  &:focus {
    ${({ haveLink, primary }) =>
      haveLink &&
      css`
        img {
          transform: scale(1.1);
        }
      `}
  }
`;
